import axios from 'axios';
import * as global from '../constants/global';

const $axios = axios.create({
  baseURL: global.apiGateway,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export default $axios;
